import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {ConfigurationService} from '../../services/configuration.service';
import {HelperService} from '../../services/helper.service';
import {LocationService} from '../../services/location.service';
import {IOption} from 'ng-select';
import{CommonAttachmentComponent} from '../../common-attachment/common-attachment.component'

@Component({
  selector: 'app-documentModel',
  templateUrl: './documentModel.component.html',
  styleUrls: ['./documentModel.component.scss']
})
export class DocumentModelComponent implements OnInit {

  public countries: Array<IOption> = [];
  public allCountries: Array<IOption> = [];
  public locations: Array<IOption> = [];
  public activeStatus: Array<IOption> = [];
  public masterData: any = {};
  public isEdit: number;
  public masterType: number;
  // employeeSystemID:any;
  // documentSystemID:any;
  // trainingRecordID:any;
  @ViewChild('swalModal') swalModal: any;
  @ViewChild('errorMessageHtml') errorMessageHtml: any;
  @ViewChild('f') form: any;

  public successMsg: string = '';
  public htmlErrorMessage: string = "";

  selectedCompanySystemID = this.helperService.getSelectedCompanyId();

  @Input("employeeSystemID") public employeeSystemID: any;
  @Input("documentSystemID") public documentSystemID: any;
  @Input("trainingRecordID") public trainingRecordID: any;

  constructor(public bsModalRef: BsModalRef,
              private configurationService: ConfigurationService,
              private helperService: HelperService,
             // private locationService: LocationService,
              private modalService: BsModalService) {
  }

  ngOnInit() {
    console.log(this.employeeSystemID);
    console.log(this.documentSystemID);
    console.log(this.trainingRecordID);
  }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  addCustomer() {
   
  }

  processSortOrder(data) {
   
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason('customer_closed');
  }
  closeModal() {
    this.bsModalRef.hide();
  }




  
}



// WEBPACK FOOTER //
// /app/src/app/configuration/documentModel/documentModel.component.ts